import Vue from "vue";

Vue.component("InputComponent", () => import("./components/element/InputComponent.vue"));
Vue.component("ButtonStyle", () => import("./components/element/ButtonStyle.vue"));
Vue.component("ButtonDropdown", () => import("./components/element/ButtonDropdown.vue"));
Vue.component("InputDropdown", () => import("./components/element/InputDropdown.vue"));
Vue.component("InputDropdownV2", () => import("./components/element/inputDropdownV2.vue"));
Vue.component("InputCitizenId", () => import("./components/element/InputCitizenId.vue"));
Vue.component("InputCitizenIdForm", () => import("./components/element/InputCitizenIdForm.vue"));
Vue.component("InputMerchantSocialSecurityID", () => import("./components/element/InputMerchantSocialSecurityID.vue"));
Vue.component("InputBranchSocialSecurityID", () => import("./components/element/InputBranchSocialSecurityID.vue"));
Vue.component("InputBranchMerchant", () => import("./components/element/InputBranchMerchant.vue"));
Vue.component("InputBranchForm", () => import("./components/element/InputBranchForm.vue"));
Vue.component("InputStatementPasscode", () => import("./components/element/InputStatementPasscode.vue"));
Vue.component("InputDropdownBankList", () => import("./components/element/InputDropdownBankList.vue"));
Vue.component("ActionDropdownIconMenu", () => import("./components/element/ActionDropdownIconMenu.vue"));
Vue.component("ThailandAddressAutocomplete", () => import("./components/element/ThailandAddressAutocomplete.vue"));
Vue.component("Tooltip", () => import("./components/element/Tooltip.vue"));
Vue.component("SwitchComponent", () => import("./components/element/SwitchComponent.vue"));
Vue.component("ModalBox", () => import("./components/modal/ModalBox.vue"));
Vue.component("Radio", () => import("./components/element/Radio.vue"));
Vue.component("CheckBox", () => import("./components/element/CheckBox.vue"));
Vue.component("CalendarSinglePicker", () => import("./components/calendar/CalendarSinglePicker.vue"));
Vue.component("Skeleton", () => import("./components/element/Skeleton.vue"));
Vue.component("TableBox", () => import("./components/table/TableBox.vue"));
Vue.component("SortButton", () => import("./components/table/SortButton.vue"));
Vue.component("DragAndDropFile", () => import("./components/element/DragAndDropFile.vue"));
Vue.component("ModalCreateDepartment", () => import("./components/modal/department/ModalCreateDepartment.vue"));
Vue.component("ModalCreatePosition", () => import("./components/modal/position/ModalCreatePosition.vue"));
Vue.component("ModalCreateEmployeeRevenueDeduct", () =>
  import("./components/modal/revenueDeduct/ModalCreateEmployeeRevenueDeduct.vue")
);
Vue.component("ModalDeleteConfirmation", () => import("./components/modal/revenueDeduct/ModalDeleteConfirmation.vue"));
Vue.component("ModalCreateEmployee", () =>
  import("./components/modal/employee/modalCreateEmployee/ModalCreateEmployee.vue")
);
Vue.component("TextArea", () => import("./components/element/TextArea.vue"));
